export default __webpack_public_path__ + "static/media/sub-category-hair-beauty-nail-station.279d4707.jpg";